import React, { useState } from 'react';
import { Button } from '../../atoms/Button/Button';
import { Note } from '../../../types/Note';
import { noteService } from '../../../services/noteService';
import MarkdownEditor from '../../atoms/MarkdownEditor/MarkdownEditor';
import './EditNoteForm.css';

interface EditNoteFormProps {
  note: Note;
  onNoteUpdated?: () => void;
  onCancel?: () => void;
}

export const EditNoteForm: React.FC<EditNoteFormProps> = ({ note, onNoteUpdated, onCancel }) => {
  const [title, setTitle] = useState(note.title);
  const [content, setContent] = useState(note.content);
  const [saving, setSaving] = useState(false);

  const formatDate = (date: Date) => {
    return new Date(date).toLocaleString('default', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleSave = async () => {
    setSaving(true);
    const updatedNote: Note = {
      ...note,
      title,
      content,
      updatedAt: new Date(),
    };
    try {
      await noteService.updateNote(note.id!, updatedNote);
      onNoteUpdated?.();
    } catch (error) {
      console.error('Error updating note:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="note-display">
      <div className="note-display__header">
        <input
          className="note-display__title-input"
          value={title}
          onChange={e => setTitle(e.target.value)}
          style={{ fontSize: '2rem', fontWeight: 700, border: 'none', background: 'transparent', width: '100%' }}
        />
        <div className="note-display__meta">
          <span className="note-display__date">
            Created: {formatDate(note.createdAt)}
          </span>
          <span className="note-display__date">
            Updated: {formatDate(note.updatedAt)}
          </span>
        </div>
        {note.tags.length > 0 && (
          <div className="note-display__tags">
            {note.tags.map((tag) => (
              <span key={tag} className="note-display__tag">
                {tag}
              </span>
            ))}
          </div>
        )}
        <div className="note-display__actions">
          <button type="button" onClick={handleSave} disabled={saving} className="note-display__edit-btn">
            {saving ? 'Saving...' : 'Save'}
          </button>
          <button type="button" onClick={onCancel} className="note-display__delete-btn" style={{ background: '#eee', color: '#333' }}>
            Cancel
          </button>
        </div>
      </div>
      <div className="note-display__content">
        <MarkdownEditor onMarkdownChange={setContent} value={content} />
      </div>
    </div>
  );
}; 